export default "__VITE_ASSET__1b83e3bb__"